import { useState, useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/pro-light-svg-icons";

import { API_URL_DONATE, fmtCurrency } from "../../utils/helpers";

import Alert from "../../components/Alert";

import ReceiptSummaryTable from "./ReceiptSummaryTable";
import ReceiptTable from "./ReceiptTable";

export default function Receipt({ cares, id, handleStatus }) {
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});
	const [details, setDetails] = useState({});
	const [payment, setPayment] = useState({});

	const initRef = useRef(false);

	useEffect(() => {
		if (initRef.current) return;
		initRef.current = true;

		init();
	});

	const init = async () => {
		const url = new URL(`${API_URL_DONATE}/`);
		const params = {
			f: `ccReceiptInit`,
			id,
			x: uuidv4(),
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url.href, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setDetails({ ...json.details, date: json.date });
				setPayment({ ...json.payment });
				setAlert({});
			} else {
				//handleStatus("", 4);
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<div id="coutoureclub">
					<h3>
						<FontAwesomeIcon icon={faCircleCheck} size="lg" /> &nbsp;CouTOURe
						Club Membership Registration Submitted
					</h3>

					{payment.method === "check" ? (
						<>
							<p>
								Thank you for registering for the 2026-2027 CouTOURe Club
								membership!
							</p>

							<p style={{ fontWeight: "400" }}>
								Please remember to remit payment by October 31, 2026.
							</p>
						</>
					) : (
						<p>
							Thank you for registering for the 2026-2027 CouTOURe Club
							membership!
						</p>
					)}

					<ReceiptSummaryTable
						data={{
							id,
							name: `${details.fname} ${details.lname}`,
							email: `${details.email}`,
							date: `${details.date}`,
							method: payment.method,
						}}
					/>

					<h3>Your Order</h3>

					<ReceiptTable data={payment} />

					<h3>Membership Referrals</h3>

					<p>
						As we continue to grow our membership through member referrals,
						please submit all prospective members and/or their contact
						information to{" "}
						<a href="mailto:coutoureclub@gmail.com">coutoureclub@gmail.com</a>.
						All prospective members will be contacted directly via email and/or
						phone to further discuss the CouTOURe Club and our direct impact on
						the community through our philanthropic support for Children's
						Charities in Palm Beach County.
					</p>
				</div>
			)}
		</>
	);
}
